import { createFileRoute } from '@tanstack/react-router';
import { ProjectsView } from '../components/features/project/index.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business Mall Div看板ページ。PI Div の PMO（pi_pmot）が Mall Div の案件を横断 PMO ビューでスコープ表示する。ProjectsView に forcedDivision='mall_div' を渡す
 * @graph-connects ProjectsView [calls] Mall Div スコープのプロジェクト一覧ビュー描画
 */
export const Route = createFileRoute('/projects/mall-div-board')({
  component: MallDivBoardPage,
});

/** @graph-connects ProjectsView [calls] Mall Div スコープのプロジェクト一覧ビュー描画 */
function MallDivBoardPage() {
  return <ProjectsView pageKey="mallDivBoard" forcedDivision="mall_div" />;
}
